



































import { Component } from "vue-property-decorator";
import Header from "@/components/header/OLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import AuthModule from "@/store/auth";
import CheckOrganizationAdminLogin from "@/utils/CheckOrganizationAdminLogin";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class ORegisterInfo extends CheckOrganizationAdminLogin {
  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }
}
